
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {ConfigResponse} from './ConfigResponse';
import {FieldModelConfigResponse} from './ConfigResponse';
import {CurrencyGroup} from '../core/CurrencyGroup';
import {FieldModelCurrencyGroup} from '../core/CurrencyGroup';

/**
 * CurrencyGroupsGetAllResponse struct
 */
class CurrencyGroupsGetAllResponse extends ConfigResponse {
  /**
   * Initialize struct
   * @param {!ConfigResponse=} parent
   * @param {!Array=} currencyGroups
   * @constructor
   */
  constructor (parent = new ConfigResponse(), currencyGroups = []) {
    super()
    super.copy(parent)
    this.CurrencyGroups = currencyGroups
  }

  /**
   * Copy struct (shallow copy)
   * @this {!CurrencyGroupsGetAllResponse}
   * @param {!CurrencyGroupsGetAllResponse} other Other struct
   * @returns {!CurrencyGroupsGetAllResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.CurrencyGroups != null) {
      this.CurrencyGroups = []
      for (let item of other.CurrencyGroups) {
        if (item != null) {
          let tempItem
          tempItem = CurrencyGroup.fromObject(item)
          this.CurrencyGroups.push(tempItem)
        } else {
          this.CurrencyGroups.push(null)
        }
      }
    } else {
      this.CurrencyGroups = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!CurrencyGroupsGetAllResponse}
   * @returns {!CurrencyGroupsGetAllResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new CurrencyGroupsGetAllResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new CurrencyGroupsGetAllResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!CurrencyGroupsGetAllResponse}
   * @param {!CurrencyGroupsGetAllResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof CurrencyGroupsGetAllResponse)) {
      throw new TypeError('Instance of CurrencyGroupsGetAllResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!CurrencyGroupsGetAllResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      CurrencyGroups: ((this.CurrencyGroups != null) ? Array.from(this.CurrencyGroups, item => ((item != null) ? item : null)) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return CurrencyGroupsGetAllResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!CurrencyGroupsGetAllResponse} other Object value
   * @returns {!CurrencyGroupsGetAllResponse} Created struct
   */
  static fromObject (other) {
    return new CurrencyGroupsGetAllResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!CurrencyGroupsGetAllResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return CurrencyGroupsGetAllResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!CurrencyGroupsGetAllResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6077
  }
}

export { CurrencyGroupsGetAllResponse };

/**
 * Fast Binary Encoding CurrencyGroupsGetAllResponse field model
 */
class FieldModelCurrencyGroupsGetAllResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelConfigResponse(buffer, 4 + 4)
    this.CurrencyGroups = new fbe.FieldModelVector(new FieldModelCurrencyGroup(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
  }

  /**
   * Get the ConfigResponse field model
   * @this {!FieldModelCurrencyGroupsGetAllResponse}
   * @returns {!FieldModelConfigResponse} ConfigResponse field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelCurrencyGroupsGetAllResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelCurrencyGroupsGetAllResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.CurrencyGroups.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelCurrencyGroupsGetAllResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.CurrencyGroups.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelCurrencyGroupsGetAllResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelCurrencyGroupsGetAllResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelCurrencyGroupsGetAllResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6077
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelCurrencyGroupsGetAllResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelCurrencyGroupsGetAllResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.CurrencyGroups.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CurrencyGroups.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CurrencyGroups.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelCurrencyGroupsGetAllResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelCurrencyGroupsGetAllResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelCurrencyGroupsGetAllResponse}
   * @param {!CurrencyGroupsGetAllResponse} fbeValue Default value, defaults is new CurrencyGroupsGetAllResponse()
   * @returns {!CurrencyGroupsGetAllResponse} CurrencyGroupsGetAllResponse value
   */
  get (fbeValue = new CurrencyGroupsGetAllResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelCurrencyGroupsGetAllResponse}
   * @param {!CurrencyGroupsGetAllResponse} fbeValue CurrencyGroupsGetAllResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.CurrencyGroups.fbeSize) <= fbeStructSize) {
      this.CurrencyGroups.get(fbeValue.CurrencyGroups)
    } else {
      fbeValue.CurrencyGroups.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CurrencyGroups.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelCurrencyGroupsGetAllResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelCurrencyGroupsGetAllResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelCurrencyGroupsGetAllResponse}
   * @param {!CurrencyGroupsGetAllResponse} fbeValue CurrencyGroupsGetAllResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelCurrencyGroupsGetAllResponse}
   * @param {CurrencyGroupsGetAllResponse} fbeValue CurrencyGroupsGetAllResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.CurrencyGroups.set(fbeValue.CurrencyGroups)
  }
}

export { FieldModelCurrencyGroupsGetAllResponse };

/**
 * Fast Binary Encoding CurrencyGroupsGetAllResponse model
 */
class CurrencyGroupsGetAllResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelCurrencyGroupsGetAllResponse(this.buffer, 4)
  }

  /**
   * Get the CurrencyGroupsGetAllResponse model
   * @this {!CurrencyGroupsGetAllResponseModel}
   * @returns {!FieldModelCurrencyGroupsGetAllResponse} model CurrencyGroupsGetAllResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!CurrencyGroupsGetAllResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!CurrencyGroupsGetAllResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return CurrencyGroupsGetAllResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!CurrencyGroupsGetAllResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelCurrencyGroupsGetAllResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!CurrencyGroupsGetAllResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!CurrencyGroupsGetAllResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!CurrencyGroupsGetAllResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!CurrencyGroupsGetAllResponseModel}
   * @param {!CurrencyGroupsGetAllResponse} value CurrencyGroupsGetAllResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!CurrencyGroupsGetAllResponseModel}
   * @param {!CurrencyGroupsGetAllResponse} value CurrencyGroupsGetAllResponse value, defaults is new CurrencyGroupsGetAllResponse()
   * @return {!object} Deserialized CurrencyGroupsGetAllResponse value and its size
   */
  deserialize (value = new CurrencyGroupsGetAllResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new CurrencyGroupsGetAllResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new CurrencyGroupsGetAllResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!CurrencyGroupsGetAllResponseModel}
   * @param {!number} prev Previous CurrencyGroupsGetAllResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { CurrencyGroupsGetAllResponseModel };
